var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShareDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_5585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.18524 14.5244C9.08953 14.2454 8.98983 13.9587 8.79044 13.7408C8.57908 13.5114 8.27999 13.3815 7.98887 13.2553L3.49454 11.3211C2.61321 10.9426 2.55738 9.76525 3.39484 9.30654C7.59806 7.01296 12.2878 5.57565 16.9177 4.16892L24.6622 1.81801C25.5276 1.55424 26.369 2.29201 26.1696 3.14064C24.9294 8.45409 23.6054 13.7523 22.1977 19.0275C22.0222 19.6812 21.121 20.289 20.6344 19.8035C19.0393 18.2247 15.7094 16.214 13.5559 15.1896C13.0575 14.9526 12.5749 20.6903 11.223 20.2087C10.3736 19.9067 9.48034 15.4036 9.18524 14.5283V14.5244Z",
    stroke: "#1F014B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88672 13.8211C11.8976 12.3379 14.37 10.0443 17.0659 8.08329C20.2322 5.78206 21.8513 5.14751 24.918 2.72778",
    stroke: "#1F014B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3535 15.5567C14.6097 13.114 16.811 11.2677 18.8608 9.37932C21.09 7.32274 23.1956 5.14384 25.1656 2.85791",
    stroke: "#1F014B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4355 19.4363C13.947 18.6221 15.1952 17.8155 16.4952 16.7146C15.6378 16.3706 14.7645 16.1603 13.8393 16.061C13.7834 16.0533 13.7236 16.0495 13.6718 16.0686C13.616 16.0877 13.5721 16.1336 13.5362 16.1833C13.1494 16.6726 13.1454 17.3377 13.0856 17.9493C13.0616 18.2169 13.0218 18.4921 12.8702 18.7177C12.7147 18.9509 12.4714 19.1573 12.4355 19.4325V19.4363Z",
    fill: "#1F014B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_5585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareDark);
export default __webpack_public_path__ + "static/media/icon_share_dark.7d93537038787968f6719981c5e4b53e.svg";
export { ForwardRef as ReactComponent };